import axios from 'axios';
import { msalInstance } from '../authConfig';
import { env } from '../config/env';
import { navigation, storage } from './browser';

const API_BASE_URL = env.apiBaseUrl;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // MSW 2 in Jest intercepts `fetch` reliably; XMLHttpRequest + axios often yields empty `response.data`.
  ...(process.env.NODE_ENV === 'test' ? { adapter: ['fetch'] as const } : {}),
});

// Add request interceptor to add auth token
api.interceptors.request.use(async (config: any) => {
  // getActiveAccount() returns null in a new tab because the active-account
  // selection is in-memory only and is not persisted across tabs.
  // Fall back to the first cached account so that cross-tab navigation
  // (e.g. deep links opened from Teams) still sends a valid auth header.
  const account =
    msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()?.[0] ?? null;
  if (account) {
    // Promote to active so subsequent calls (and getActiveAccount in other
    // places) also resolve correctly for the lifetime of this tab.
    if (!msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(account);
    }
    if (config.headers) {
      const response = await msalInstance.acquireTokenSilent({
        scopes: ['User.Read'],
        account,
      });
      config.headers.Authorization = `Bearer ${response.idToken}`;
    }
  }
  return config;
});

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    if (error.response?.status === 401) {
      // Handle unauthorized access - clear session and redirect to login
      msalInstance.setActiveAccount(null);
      msalInstance.clearCache();
      storage.clearAll();
      navigation.redirectTo('/');
    }
    return Promise.reject(error);
  }
);

export default api; 